import { render, staticRenderFns } from "./congrats.vue?vue&type=template&id=c5f1ef08&scoped=true"
import script from "./congrats.vue?vue&type=script&lang=js"
export * from "./congrats.vue?vue&type=script&lang=js"
import style0 from "./congrats.scss?vue&type=style&index=0&id=c5f1ef08&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f1ef08",
  null
  
)

export default component.exports